import clsx from 'clsx';
import React from 'react';
import { ProductStatus } from '../../../../types/Products/product';
import { Props } from './ProductCard';

export const ProductQuantity = ({
  status,
  quantity,
  save_as,
}: Pick<Props, 'quantity' | 'save_as'> & { status: ProductStatus }) => {
  const tagStyle = clsx(
    'capitalize text-xs',
    ['in stock', 'on sale'].includes(status) && 'text-[rgba(48,191,38,1)]',
    status == 'low stock' && 'text-[rgba(245,198,21,1)]',
    status == 'out of stock' && 'medium-emphasis-text'
  );

  return (
    <small className="w-full space-x-1 medium-emphasis-text">
      <span className={tagStyle}>
        <small>
          {['in stock', 'on sale'].includes(status) && `✓ ${status}:`}
          {status == 'low stock' && `⚠️ ${status}:`}
          {status == 'out of stock' && `❌ ${status}:`}
        </small>
      </span>
      <span>{quantity} units</span>
      <span>
        {' '}
        • Saved as <span className="font-semibold capitalize">{save_as}</span>
      </span>
    </small>
  );
};
